import { render, staticRenderFns } from "./StartGuide.vue?vue&type=template&id=467aa224&scoped=true&"
import script from "./StartGuide.vue?vue&type=script&lang=js&"
export * from "./StartGuide.vue?vue&type=script&lang=js&"
import style0 from "./StartGuide.vue?vue&type=style&index=0&id=467aa224&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467aa224",
  null
  
)

export default component.exports